import React, { useState } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { deleteCompany } from "../../../services/company.service";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedIds = [], onDeleteSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // Gérer la suppression des entreprises sélectionnées
  const handleDelete = async () => {
    if (selectedIds.length === 0) return;
    
    setIsDeleting(true);
    
    try {
      // Supprimer chaque entreprise sélectionnée
      const deletePromises = selectedIds.map(id => deleteCompany(id));
      await Promise.all(deletePromises);
      
      showSuccess(`${selectedIds.length} entreprise(s) supprimée(s) avec succès`);
      
      // Notifier le composant parent pour mettre à jour la liste
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      showError(`Erreur lors de la suppression: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };

  // Ne pas afficher le panel si aucune entreprise n'est sélectionnée
  if (selectedIds.length === 0) {
    return null;
  }

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedIds.length} entreprise(s)</span> sélectionnée(s)
      </div>
      <button 
        className={cn("button", styles.button, { [styles.loading]: isDeleting })} 
        onClick={handleDelete}
        disabled={isDeleting}
      >
        {isDeleting ? 'Suppression...' : 'Supprimer'}
      </button>
    </div>
  );
};

export default Panel;
